import { useOutletContext } from 'react-router-dom'
import type { AppShellContext } from '../components/AppShell'
import { DeskGrid } from '../components/desk/DeskGrid'
import {
  AgentHealthModule,
  AgentsModule,
  CloudWatchModule,
  EngineModule,
  GoalsModule,
  MarketModule,
  ModelsModule,
  OperatorModule,
  RiskMonitorModule,
  RunsModule,
  SanityGateModule,
  ServicesModule,
  SignalPipelineModule,
} from '../components/desk/OpsModules'
import { useIsMobile } from '../hooks/useMediaQuery'
import { OpsLegacyBody } from './OpsLegacyBody'

/**
 * Operations console. Desktop: a no-scroll DeskGrid of thirteen platform
 * modules (row 1: six stat tiles; row 2: agent health + signal pipeline;
 * row 3: sanity gate, risk monitor, models, goals, operator); each opens its
 * drawer. Phone keeps the legacy zones (OpsLegacyBody).
 */
export function OpsPage() {
  // Hooks run unconditionally, before the phone branch.
  const { ws } = useOutletContext<AppShellContext>()
  const isMobile = useIsMobile()

  if (isMobile) return <OpsLegacyBody ws={ws} />

  return (
    <main className="dashboard-content desk-page ops-page">
      <DeskGrid>
        <EngineModule />
        <RunsModule />
        <ServicesModule />
        <CloudWatchModule />
        <AgentsModule />
        <MarketModule />

        <AgentHealthModule />
        <SignalPipelineModule />

        <SanityGateModule />
        <RiskMonitorModule />
        <ModelsModule />
        <GoalsModule />
        <OperatorModule />
      </DeskGrid>
    </main>
  )
}
